import { ReactNode, Ref } from 'react';
import styles from './section.module.css';
import clsx from 'clsx';

interface SectionProps {
  children: React.ReactNode;
  isFormSection?: boolean;
  className?: string;
  title?: ReactNode;
  classNameSection?: string;
  ref?: Ref<HTMLDivElement>;
  dataTestId?: string;
}

export function Section({
  children,
  className,
  isFormSection = true,
  title,
  classNameSection,
  ref,
  dataTestId,
}: SectionProps) {
  return (
    <section
      className={clsx(isFormSection && styles.formSection, classNameSection)}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      {title && (
        <div className={styles.sectionTitle}>
          {typeof title === 'string' ? <h2 className="h4">{title}</h2> : title}
        </div>
      )}
      <div ref={ref} className={clsx(styles.sectionContainer, className)}>
        {children}
      </div>
    </section>
  );
}
